import { render, staticRenderFns } from "./ZhuyaoyuqinglaiyuanDetail.vue?vue&type=template&id=42a7f0c1&scoped=true&"
import script from "./ZhuyaoyuqinglaiyuanDetail.vue?vue&type=script&lang=js&"
export * from "./ZhuyaoyuqinglaiyuanDetail.vue?vue&type=script&lang=js&"
import style0 from "./ZhuyaoyuqinglaiyuanDetail.vue?vue&type=style&index=0&id=42a7f0c1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a7f0c1",
  null
  
)

export default component.exports